// extracted by mini-css-extract-plugin
export default {"container":"AsyncImage_container__2z2nh","info":"AsyncImage_info__X3ocC","loading":"AsyncImage_loading__eX33D","shimmer":"AsyncImage_shimmer__AJESd"};